import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  setMedicalDeviceOrderingCompanyList,
  setMedicalDeviceOrderingOrderList,
  setMedicalDeviceOrderingPatientAddresses,
  setMedicalDeviceOrderingPatientProfile,
  setMedicalDeviceOrderingTypeList
} from 'src/store/modules/admin'
import {
  getMedicalDeviceTypes,
  getPatientAddresses,
  getPatientProfile
} from 'src/store/modules/common'

import {
  ADMIN_MEDICAL_DEVICE_ORDERING_GET_LIST,
  ADMIN_MEDICAL_DEVICE_ORDERING_PATCH_ORDER,
  ADMIN_MEDICAL_DEVICE_ORDERING_POST_CANCEL,
  COMPANIES,
  MEDICAL_DEVICE_ORDERING_CANCEL_ORDER_MESSAGE,
  MEDICAL_DEVICE_ORDERING_SAVE_ORDER_MESSAGE
} from 'src/constants'
import { showSuccessModal } from 'src/services/dialogs'

export const fetchMedicalDeviceOrders =
  (config = {}) =>
  async (dispatch) => {
    const { params = {}, query = {} } = config

    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: ADMIN_MEDICAL_DEVICE_ORDERING_GET_LIST,
          params,
          query
        }
      })

      dispatch(setMedicalDeviceOrderingOrderList(items))

      return meta
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const updateMedicalDeviceOrder =
  (config = {}) =>
  async () => {
    const { params = {}, payload = {} } = config

    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: ADMIN_MEDICAL_DEVICE_ORDERING_PATCH_ORDER,
          params
        },
        payload
      })

      showSuccessModal({
        content: MEDICAL_DEVICE_ORDERING_SAVE_ORDER_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const cancelMedicalDeviceOrder =
  (config = {}) =>
  async () => {
    const { params = {} } = config

    try {
      await httpClient.request({
        method: 'post',
        url: {
          pathname: ADMIN_MEDICAL_DEVICE_ORDERING_POST_CANCEL,
          params
        }
      })

      showSuccessModal({
        content: MEDICAL_DEVICE_ORDERING_CANCEL_ORDER_MESSAGE,
        centered: true,
        keyboard: false
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const fetchDropdownCompanyList =
  (config = {}) =>
  async (dispatch) => {
    const { params = {}, query = {} } = config

    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: COMPANIES,
          params,
          query
        }
      })

      dispatch(setMedicalDeviceOrderingCompanyList(items))

      return meta
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const fetchMedicalDeviceOrderingPatientAddresses =
  (config = {}) =>
  async (dispatch) => {
    const patientAddresses = await getPatientAddresses(config)

    dispatch(setMedicalDeviceOrderingPatientAddresses(patientAddresses))
  }

export const fetchMedicalDeviceOrderingPatientProfile =
  (config = {}) =>
  async (dispatch) => {
    const patientProfile = await getPatientProfile(config)

    dispatch(setMedicalDeviceOrderingPatientProfile(patientProfile))
  }

export const fetchMedicalDeviceOrderingTypeList =
  (config = {}) =>
  async (dispatch) => {
    const typeList = await getMedicalDeviceTypes(config)

    dispatch(setMedicalDeviceOrderingTypeList(typeList))
  }
